
import { Image, useScroll } from "@react-three/drei"
import { useFrame } from "@react-three/fiber"
import { useRef } from "react"
import { mainStore } from "../../store"


export default function Avoine(props) {

    const group = useRef()

    const data = useScroll()

    const colors = mainStore.useStore(s => s.colors)


    useFrame(() => {
        // group.current.children[0].position.z = 1.6 - data.range(0, 1 / 3) / 2
        // group.current.children[1].position.z = 1.25 - data.range(0, 1 / 3) / 3
    })


    return <group ref={group} {...props}>
        <Image
            url={import.meta.env.BASE_URL + 'static/img/avoine-overlay.webp'}
            transparent
            scale={3}
            zoom={0.9}
            segments={4}
            position={[1.5, 0, 1.35]}
            rotation={[0, 0, 0]}
            toneMapped={false}
            color={colors.clear}
        />

        <Image
            url={import.meta.env.BASE_URL + 'static/img/avoine.webp'}
            transparent
            scale={3.4}
            zoom={0.9}
            segments={4}
            position={[1.75, -0.1, 1.33]}
            rotation={[0, 0, 0]}
            toneMapped={false}
            color={colors.clear}
        />

        <Image
            url={import.meta.env.BASE_URL + 'static/img/avoine-bg.webp'}
            transparent
            scale={3.2}
            zoom={0.85}
            segments={4}
            position={[1.5, -0.1, 1.25]}
            rotation={[0, 0, 0]}
            toneMapped={false}
            color={colors.clear}
        />
    </group>
}